import { render, staticRenderFns } from "./FiltersArea.vue?vue&type=template&id=2546e47e&scoped=true&"
import script from "./FiltersArea.vue?vue&type=script&lang=js&"
export * from "./FiltersArea.vue?vue&type=script&lang=js&"
import style0 from "./FiltersArea.vue?vue&type=style&index=0&id=2546e47e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2546e47e",
  null
  
)

export default component.exports